import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';

import { routes } from '@model/constants/routes';
import { DecisionModelResposeType, DecisionModelValidationsType } from '../models';
import { DecisionModelProcessType, ProductType } from '@core/model/enums';

@Injectable({
  providedIn: 'root',
})
export class DecisionModelService {
  private apiGatewayUrl: string;

  constructor(private http: HttpClient) {
    this.apiGatewayUrl = environment.apiGatewayUrl;
  }

  public initialValidations(): Observable<DecisionModelResposeType> {
    return this.http.post<DecisionModelResposeType>(`${this.apiGatewayUrl}${routes.initialValidations}`, {});
  }

  public executeDecisionModel(decisionModelWorkflow: {
    decisionModelProcessType: DecisionModelProcessType;
    productType: ProductType;
  }): Observable<DecisionModelValidationsType> {
    return this.http.post<DecisionModelValidationsType>(
      `${this.apiGatewayUrl}${routes.decisionModelValidations}`,
      decisionModelWorkflow
    );
  }

  public finalValidations(): Observable<DecisionModelResposeType> {
    return this.http.post<DecisionModelResposeType>(`${this.apiGatewayUrl}${routes.finalValidations}`, {});
  }
}
